module.exports = __webpack_public_path__ + "ae7a49185ddd5749956de4891011345b.svg";